<template lang='pug'>
#card-percentual-alertas-dashboard-operacao
    h2.mb-3 {{ $t('mensagens.operacao.dashboard.alertasCriterioSocio') }}

    el-skeleton(:rows='1' :loading='loading' animated)
        template(v-slot:template)
            .card-percentual-alertas-dashboard-operacao__grafico(:style='loading ? "padding: 0; box-shadow: none; height: 60px;" : "height: 550px"' v-loading='loading')

        template
            .card-percentual-alertas-dashboard-operacao__grafico(:style='erro || payload.length === 0 ? "height: 60px; padding: 20px; opacity: 0.8" : ""')
                div(v-if='erro')
                    h4 {{ $t('mensagens.operacao.dashboard.erroAlertasCriterioSocio') }}

                div(v-if='payload.length === 0')
                    h4 {{ $t('mensagens.operacao.dashboard.semDadosAlertasCriterioSocio') }}

                GraficoColuna(
                    v-else
                    id='card-percentual-alertas-dashboard-operacao__grafico-grafico',
                    type='ColumnChart',
                    :data='payload',
                    :options='opcaoGrafico'
                )
</template>

<script>
import DiagnosticoSociambientealRepresentante from '@/components/ModalDiagnosticoSocioambientalRepresentante.vue';
import { GChart as GraficoColuna } from 'vue-google-charts/legacy';

export default {
    name: 'CardPercentualAlertasDashboardOperacao',
    components: { GraficoColuna, DiagnosticoSociambientealRepresentante },
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        titulo: {
            type: String,
            required: true
        },
        payload: {
            type: Array,
            required: true,
            default: () => ([['', '']])
        },
        erro: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        titulo: function (novoTitulo) {
            this.opcaoGrafico.vAxis.title = novoTitulo;
        }
    },

    data: () => ({
        opcaoGrafico: {
            vAxis: {
                title: 'Porcentagem',
                titleTextStyle: {
                    italic: false,
                    bold: true,
                    fontSize: 14
                },
                textPosition: 'out'
            },
            hAxis: {
                textStyle: {
                    fontSize: 14
                }
            },
            width: '100%',
            height: 550,
            colors: ['#00413c'],
            tooltip: { isHtml: true },
            legend: { position: 'none' },
            chartArea: { width: '90%', height: '550px' },
            animation: {
                duration: 600,
                easing: 'out',
                startup: true
            }
        }
    })
};
</script>

<style lang='scss' scoped>
#card-percentual-alertas-dashboard-operacao {
    width: 100%;
    height: auto;

    .card-percentual-alertas-dashboard-operacao__grafico {
        padding-left: 35px;
        height: 550px;
        background: white;
        border-radius: 5px;
        box-shadow: 0 1px 3px 0 var(--block-shadow);
        overflow: hidden;
        transition: all 0.5s ease;
    }

    .card-percentual-alertas-dashboard-operacao__grafico__skeleton {
        height: 100%;
        width: 100%;
        border-radius: 5px;
    }

    #card-percentual-alertas-dashboard-operacao__grafico-grafico {
        margin-top: -25px;
    }

    .bar-grafico {
        height: 100%;
        width: 100%;
    }
}
</style>
